module.exports = __webpack_public_path__ + "img/store.7d7e2a80.svg";